<mat-card appearance="outlined" class="widget">
    <mat-card-title class="card-title">{{ age?.name }}</mat-card-title>
    <mat-card-content>
        <div class="age">
            {{ age?.diff }}
        </div>
    </mat-card-content>
</mat-card>
